import { useContext } from 'react';
import { DialogSessionContext } from './context';

export const useDialogSession = () => {
  const value = useContext(DialogSessionContext);
  if (value === null) {
    throw new Error('useDialogSession must be used within DialogSession');
  }
  return value;
};

/**
 * Optional version: returns null when used outside DialogSession.
 * Use when the component can work both with and without the session (e.g. fallback to useAudioPlayer).
 */
export const useDialogSessionOptional = () => {
  return useContext(DialogSessionContext);
};
